import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'

const resource = '/merchant'
const changePasswordresource = '/merchant/user/change-password'

export default {
  login(payload) {
    return Repository.post(`${resource}/login`, payload)
  },
  getPermissions() {
    return OperationRepository.get(`${resource}/user/get-current-permissions`)
  },
  getCurrentUser() {
    return OperationRepository.get(`${resource}/user/get-current`)
  },
  changeUserPassword(payload) {
    return Repository.post(`${changePasswordresource}`, payload)
  },
  forgotPasswordEmailSubmit(payload) {
    return Repository.post(`${resource}/forgot-password`, payload)
  },
  forgotPasswordTokenVerify(token) {
    return Repository.get(`${resource}/forgot-password/${token}`)
  },
  forgotPasswordReset(payload) {
    return Repository.post(`${resource}/reset-password`, payload)
  },
}
